/**
 * DATA CONTOH — hanya untuk membangun UI.
 *
 * Semua isi file ini diganti panggilan API lewat lib/api-client.ts begitu backend
 * siap. Bentuk datanya sengaja dibuat menyerupai response service terkait
 * (PRD Microservice §3) agar penggantiannya minim perubahan komponen.
 *
 * Jangan menambah logika bisnis di sini — harga, kelayakan member, dan batas
 * pembelian ditegakkan backend (PRD Keamanan §5.3).
 */

export interface Tier {
  id: string;
  name: string;
  tagline: string;
  pricePerSeason: number;
  highlighted: boolean;
  benefits: string[];
  /** Kunci di AppAssets */
  crest: string;
}

/** membership: GET /v1/tiers */
export const TIERS: Tier[] = [
  {
    id: "silver",
    crest: "membershipSilverCrest",
    name: "Silver",
    tagline: "Dasar Kesetiaan",
    pricePerSeason: 150_000,
    highlighted: false,
    benefits: ["Diskon merchandise 5%", "Akses berita prioritas", "Kartu digital Borneo ID"],
  },
  {
    id: "gold",
    crest: "membershipGoldCrest",
    name: "Gold Elite",
    tagline: "The Manyala Tier",
    pricePerSeason: 500_000,
    highlighted: true,
    benefits: [
      "Kartu digital Borneo ID",
      "Early bird tiket 24 jam",
      "Diskon merchandise 15%",
      "Undangan meet & greet online",
      "Konten VOD eksklusif",
    ],
  },
  {
    id: "platinum",
    crest: "membershipPlatinumCrest",
    name: "Platinum",
    tagline: "Ultimate Fan Experience",
    pricePerSeason: 1_500_000,
    highlighted: false,
    benefits: [
      "Kartu digital Borneo ID",
      "Akses VVIP lounge",
      "Jersey bertanda tangan",
      "Diskon merchandise 25%",
      "Prioritas season ticket",
    ],
  },
];

export const BENEFIT_MATRIX = [
  { label: "Diskon toko", silver: "5%", gold: "15%", platinum: "25%" },
  { label: "Pre-order tiket", silver: false, gold: true, platinum: true },
  { label: "Konten eksklusif", silver: true, gold: true, platinum: true },
  { label: "Meet & greet", silver: false, gold: true, platinum: true },
];

/** identity: GET /v1/me */
export const PROFILE = {
  borneoId: "BRN-9920-1250",
  name: "Reza Pratama",
  /** Ditampilkan tersamar — data pribadi minimum (PRD Keamanan §8.2) */
  email: "r****a@gmail.com",
  phone: "+62 812-****-8891",
  tier: "Gold Elite",
  since: "Okt 2021",
  validUntil: "30 Juni 2027",
  verified: true,
};

/** Statistik Pusamania — ringkasan lintas service, dihitung backend */
export const PROFILE_STATS = [
  { id: "matches", value: "12", label: "Laga" },
  { id: "years", value: "3", label: "Tahun" },
];

/** ticketing: GET /v1/events — dipakai di ringkasan beranda */
export const UPCOMING_MATCH = {
  id: "borneo-persib",
  competition: "Liga 1 Indonesia",
  home: "Borneo FC",
  away: "Persib",
  kickoff: "Sabtu, 30 Agustus 2026 · 15:30 WITA",
  venue: "Stadion Segiri, Samarinda",
  startingPrice: 85_000,
  status: "Tiket dibuka 25 Agustus",
};

export const CONSENTS = [
  {
    id: "service",
    title: "Data untuk layanan",
    description:
      "Diperlukan agar tiket, membership, dan pembayaran dapat diproses. Tidak bisa dinonaktifkan.",
    required: true,
    granted: true,
  },
  {
    id: "marketing",
    title: "Promosi & penawaran",
    description: "Kabar diskon merchandise, penawaran sponsor, dan kampanye klub.",
    required: false,
    granted: false,
  },
  {
    id: "analytics",
    title: "Analitik penggunaan",
    description: "Membantu kami memperbaiki aplikasi. Data digunakan secara agregat.",
    required: false,
    granted: true,
  },
];

export function formatRupiah(value: number): string {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(value);
}
